(function () {
  function isHomePage() {
    // Shopify standard: body.template-index na stronie głównej
    return document.body.classList.contains("template-index") || document.body.id === "index";
  }

  function initRevealHomeOnly() {
    // Jeśli nie home — zdejmij ewentualne klasy i WYJDŹ
    if (!isHomePage()) {
      document.documentElement.classList.remove("reveal-prep");
      document.documentElement.classList.remove("reveal-init");
      return;
    }

    // Home: włącz animacje
    document.documentElement.classList.add("reveal-init");

    const sections = Array.from(
      document.querySelectorAll(
        "main [data-section-id], main .shopify-section, main .section, main .page-width, #MainContent > *"
      )
    );

    if (!sections.length) {
      document.documentElement.classList.remove("reveal-prep");
      return;
    }

    // Banner / hero (pierwsza sekcja) – animacja po starcie
    const hero = sections[0];
    if (hero) {
      hero.classList.add("reveal-on-scroll");
      hero.getBoundingClientRect(); // reflow
      setTimeout(() => hero.classList.add("is-visible"), 160);
    }

    // Reszta sekcji przy scrollu
    const rest = sections.slice(1);
    rest.forEach(el => el.classList.add("reveal-on-scroll"));

    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18, rootMargin: "0px 0px -15% 0px" });

    rest.forEach(el => io.observe(el));

    // Zdejmij tryb anti-flicker dopiero po przygotowaniu klas
    document.documentElement.classList.remove("reveal-prep");
  }

  document.addEventListener("DOMContentLoaded", initRevealHomeOnly);
  document.addEventListener("shopify:section:load", initRevealHomeOnly);
  document.addEventListener("shopify:section:reorder", initRevealHomeOnly);

  // Jeśli DOM już gotowy (czasem w preview), odpal od razu
  if (document.readyState !== "loading") initRevealHomeOnly();
})();
